import {
    Container,
    Card,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    CardFooter
} from 'reactstrap';
import AddProjectsAndUpload from './AddProjectsAndUpload/AddProjectsAndUpload';
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs/Breadcrumbs';
import {
    AboutMe,
    Address,
    City,
    Company,
    Country,
    FirstName,
    Gender,
    LastName,
    PostalCode,
    UserDetail,
    Username,
    Users
} from '../../../../utils/Constant';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Btn, H3, H6, Image, P } from '../../../../AbstractElements';
import { dynamicImage } from '../../../../Service';
import { Bio, Emailaddress, MyProfile, Password, Save, Website } from '../../../../utils/Constant';
import CardHeaderCommon from '../../../../CommonElements/CardHeaderCommon/CardHeaderCommon';
import { useEffect, useRef, useState } from 'react';
import { User } from '../../../../Types/Users';
import { usersApi } from '../../../../Api';
import DataTable from 'react-data-table-component';
import { productListTableDataColumn } from '../../../../Data/Application/Ecommerce/ProductList';
import { notification } from 'antd';
import { handleUploadFiles } from '../../../../utils/helper/functions';
import CommonFileUpload from '../../../Common/CommonFileUpload';
import { toast } from 'react-toastify';

const UserDetailContainer = ({ user_type_id }: { user_type_id: string }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [uploadFiles, setUploadFiles] = useState<File[]>([]);
    const [imagePreviewUrl, setImagePreviewUrl] = useState<string | null>(null);
    const [userDetail, setUserDetail] = useState<User>({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        user_type_id: user_type_id,
        // user_type: {
        //     id: user_type_id
        // },
        gender: 'male'
    });
    const [loadingUserDetail, setLoadingUserDetail] = useState(false);
    const handleSetUserDetail = (e: any) => {
        setUserDetail({ ...userDetail, ...e });
    };

    const getDetail = () => {
        if (id) {
            setLoadingUserDetail(true);
            usersApi
                .getDetail(Number(id))
                .then((res) => {
                    setUserDetail(res.data);
                    setLoadingUserDetail(false);
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    };

    const createUser = (imgUrls: string[]) => {
        const data: any = {};
        if (imgUrls.length > 0) {
            data.profile_picture_url = imgUrls[0];
        }
        usersApi
            .create({ ...userDetail, ...data })
            .then((res) => {
                toast.success('Create success');
                switch (user_type_id) {
                    case '2':
                        navigate(`/suppliers`);
                        break;
                    case '3':
                        navigate(`/customers`);
                        break;

                    default:
                        break;
                }
            })
            .catch((err) => {
                console.error(err);
                toast.warning('Something has occurred !!!');
            });
    };

    const updateUser = (imgUrls: string[]) => {
        setLoadingUserDetail(true);
        const data: any = {};
        if (imgUrls.length > 0) {
            data.profile_picture_url = imgUrls[0];
        }
        data.user_type_id = String(userDetail.user_type_id);
        usersApi
            .update(Number(id), { ...userDetail, ...data })
            .then((res) => {
                setUserDetail(res.data);
                setLoadingUserDetail(false);
                toast.success('Update success');
            })
            .catch((err) => {
                console.error(err);
                toast.warning('Something has occurred !!!');
            });
    };

    const formSubmit = async () => {
        if (
            userDetail.first_name &&
            userDetail.last_name &&
            userDetail.email &&
            userDetail.password
        ) {
            const imgUrls = await handleUploadFiles(uploadFiles);
            if (id) {
                updateUser(imgUrls);
            } else {
                createUser(imgUrls);
            }
        } else toast.warning('Missing required fields !!!');
    };

    const handleIconClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = (event: any) => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }
        setImagePreviewUrl(URL.createObjectURL(file));
        setUploadFiles([file]);
    };

    useEffect(() => {
        getDetail();
    }, []);

    useEffect(() => {
        return () => {
            if (imagePreviewUrl) {
                URL.revokeObjectURL(imagePreviewUrl);
            }
        };
    }, [imagePreviewUrl]);    

    return (
        <>
            <Breadcrumbs
                mainTitle={'Detail'}
                parent={user_type_id === '2' ? 'Suppliers' : 'Customers'}
            />
            <Container fluid>
                <div className="edit-profile">
                    <Row>
                        <Col xl="4">
                            <Card>
                                <CardHeaderCommon
                                    title={''}
                                    tagClass="card-title mb-0"
                                />
                                <CardBody>
                                    <Form>
                                        <Row className="mb-2">
                                            <div className="profile-title">
                                                <div className="d-flex">
                                                    {/* <CommonFileUpload
                                                        multiple
                                                        handleSetUploadedFiles={setUploadFiles}
                                                    /> */}
                                                    <div
                                                        style={{
                                                            position: 'relative',
                                                            display: 'inline-block',
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={handleIconClick}
                                                        >
                                                        <Image
                                                            className="img-70 rounded-circle"
                                                            alt="edit-user"
                                                            src={
                                                                imagePreviewUrl ??
                                                                userDetail.profile_picture_url ??
                                                                dynamicImage('user/7.jpg')
                                                            }
                                                            
                                                        />
                                                        <input
                                                            type="file"
                                                            multiple={false}
                                                            ref={fileInputRef}
                                                            onChange={handleFileChange}
                                                            style={{ display: 'none' }}
                                                            accept="image/png, image/jpeg, image/gif"
                                                        />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <H3 className="mb-1">
                                                            {userDetail.first_name}{' '}
                                                            {userDetail.last_name}
                                                        </H3>
                                                        {/* <P>{userDetail.}</P> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </Row>
                                        <FormGroup>
                                            <H6 className="form-label">{Bio}</H6>
                                            <textarea
                                                rows={5}
                                                className="form-control"
                                                value={userDetail.bio}
                                                onChange={(e) =>
                                                    handleSetUserDetail({ bio: e.target.value })
                                                }
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{Emailaddress}</Label>
                                            <Input
                                                placeholder="your-email@domain.com"
                                                value={userDetail.email}
                                                onChange={(e) =>
                                                    handleSetUserDetail({ email: e.target.value })
                                                }
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{Password}</Label>
                                            <Input
                                                type="password"
                                                disabled={id ? true : false}
                                                value={userDetail.password}
                                                onChange={(e) =>
                                                    handleSetUserDetail({
                                                        password: e.target.value
                                                    })
                                                }
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{Website}</Label>
                                            <Input
                                                placeholder="Your website Url"
                                                value={userDetail.website_url}
                                                onChange={(e) =>
                                                    handleSetUserDetail({
                                                        website_url: e.target.value
                                                    })
                                                }
                                            />
                                        </FormGroup>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xl="8">
                            <Form>
                                <Card>
                                    <CardHeaderCommon
                                        title={''}
                                        tagClass={'card-title mb-0'}
                                    />
                                    <CardBody>
                                        <Row>
                                            <Col
                                                sm="6"
                                                md="6">
                                                <FormGroup>
                                                    <Label>{FirstName}</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="First Name"
                                                        value={userDetail.first_name}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                first_name: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="6"
                                                md="6">
                                                <FormGroup>
                                                    <Label>{LastName}</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="Last Name"
                                                        value={userDetail.last_name}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                last_name: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="6"
                                                md="4">
                                                <FormGroup>
                                                    <Label>Phone</Label>
                                                    <Input
                                                        type="number"
                                                        placeholder="Phone"
                                                        value={userDetail.mobileNo}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                mobileNo: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="5">
                                                <FormGroup>
                                                    <Label>Company</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="Company"
                                                        value={userDetail.company}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                company: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="6"
                                                md="3">
                                                <FormGroup>
                                                    <Label>Email address</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="Position"
                                                        value={userDetail.email}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                email: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup>
                                                    <Label>{Address}</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="Home Address"
                                                        value={userDetail.address}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                address: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="6"
                                                md="4">
                                                <FormGroup>
                                                    <Label>City</Label>
                                                    <Input
                                                        type="text"
                                                        placeholder="City"
                                                        value={userDetail.city}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                city: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="6"
                                                md="3">
                                                <FormGroup>
                                                    <Label>{PostalCode}</Label>
                                                    <Input
                                                        type="number"
                                                        placeholder="ZIP Code"
                                                        value={userDetail.postal_code}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                postal_code: e.target.value
                                                            })
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="5">
                                                <FormGroup>
                                                    <Label>{Gender}</Label>
                                                    <Input
                                                        type="select"
                                                        className="btn-square form-select"
                                                        value={userDetail.gender}
                                                        onChange={(e) =>
                                                            handleSetUserDetail({
                                                                gender: e.target.value
                                                            })
                                                        }>
                                                        <option value={'male'}>{'Male'}</option>
                                                        <option value={'female'}>{'Female'}</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <Label>{AboutMe}</Label>
                                                <textarea
                                                    className="form-control"
                                                    rows={3}
                                                    placeholder="Enter About your description"
                                                    value={userDetail.about_me}
                                                    onChange={(e) =>
                                                        handleSetUserDetail({
                                                            about_me: e.target.value
                                                        })
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    </CardBody>
                                    <CardFooter className="text-end">
                                        <Btn
                                            color="primary"
                                            onClick={() => formSubmit()}>
                                            {id ? 'Update' : 'Submit'}
                                        </Btn>
                                    </CardFooter>
                                </Card>
                            </Form>
                        </Col>
                        {user_type_id === '2' && id && userDetail.products && (
                            <Col md="12">
                                <Card className="custom-project-card">
                                    <DataTable
                                        data={userDetail.products}
                                        columns={productListTableDataColumn}
                                        progressPending={loadingUserDetail}
                                        striped
                                        highlightOnHover
                                        pagination={false}
                                    />
                                </Card>
                            </Col>
                        )}
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default UserDetailContainer;
